// extracted by mini-css-extract-plugin
module.exports = {"gallery_grid":"Styles_gallery_grid__rn5Nb","gallery_mobile_carousel":"Styles_gallery_mobile_carousel__KjoEX","lightbox":"Styles_lightbox__HODzQ"};